export default __webpack_public_path__ + "static/media/logo.7b462ec3.png";